export const CREATE_TIMESHEET_ROW_REQUEST = 'CREATE_TIMESHEET_ROW_REQUEST';
export const CREATE_TIMESHEET_ROW_REQUEST_FAILURE = 'CREATE_TIMESHEET_ROW_REQUEST_FAILURE';
export const CREATE_TIMESHEET_ROW_REQUEST_SUCCESS = 'CREATE_TIMESHEET_ROW_REQUEST_SUCCESS';

export const DELETE_TIMESHEET_ROW_REQUEST = 'DELETE_TIMESHEET_ROW_REQUEST';
export const DELETE_TIMESHEET_ROW_REQUEST_FAILURE = 'DELETE_TIMESHEET_ROW_REQUEST_FAILURE';
export const DELETE_TIMESHEET_ROW_REQUEST_SUCCESS = 'DELETE_TIMESHEET_ROW_REQUEST_SUCCESS';

export const GET_TIMESHEET_ROW_REQUEST = 'GET_TIMESHEET_ROW_REQUEST';
export const GET_TIMESHEET_ROW_REQUEST_FAILURE = 'GET_TIMESHEET_ROW_REQUEST_FAILURE';
export const GET_TIMESHEET_ROW_REQUEST_SUCCESS = 'GET_TIMESHEET_ROW_REQUEST_SUCCESS';

export const GET_TIMESHEET_ROWS_REQUEST = 'GET_TIMESHEET_ROWS_REQUEST';
export const GET_TIMESHEET_ROWS_REQUEST_FAILURE = 'GET_TIMESHEET_ROWS_REQUEST_FAILURE';
export const GET_TIMESHEET_ROWS_REQUEST_SUCCESS = 'GET_TIMESHEET_ROWS_REQUEST_SUCCESS';

export const RESET_TIMESHEET_ROWS_STATE = 'RESET_TIMESHEET_ROWS_STATE';

export const TOGGLE_ROW_BILLABLE_REQUEST = 'TOGGLE_ROW_BILLABLE_REQUEST';
export const TOGGLE_ROW_BILLABLE_REQUEST_FAILURE = 'TOGGLE_ROW_BILLABLE_REQUEST_FAILURE';
export const TOGGLE_ROW_BILLABLE_REQUEST_SUCCESS = 'TOGGLE_ROW_BILLABLE_REQUEST_SUCCESS';

export const UPDATE_TIMESHEET_ROW_REQUEST = 'UPDATE_TIMESHEET_ROW_REQUEST';
export const UPDATE_TIMESHEET_ROW_REQUEST_FAILURE = 'UPDATE_TIMESHEET_ROW_REQUEST_FAILURE';
export const UPDATE_TIMESHEET_ROW_REQUEST_SUCCESS = 'UPDATE_TIMESHEET_ROW_REQUEST_SUCCESS';
